const navBar = document.querySelector('nav.navbar')
const ctaBox = document.querySelector('.cta-box')
const style = getComputedStyle(document.body)

let lastScrollTop = 0

window.addEventListener('scroll', function () {
  let currentScroll = window.scrollY

  if (currentScroll > 300) {
    if (!ctaBox.classList.contains('cta-box-float'))
      ctaBox.classList.add('cta-box-float')
  } else {
    ctaBox.classList.remove('cta-box-float')
  }

  if (currentScroll > parseFloat(style.getPropertyValue('--header-height'))) {
    if (currentScroll > lastScrollTop) {
      navBar.classList.remove('nav-float-show')
      navBar.classList.add('nav-float-hide')

      document
        .querySelectorAll('.menu-item-has-children')
        .forEach((element) => {
          element.classList.remove('open')
        })
    } else if (currentScroll < lastScrollTop) {
      navBar.classList.remove('nav-float-hide')
      navBar.classList.add('nav-float-show', 'nav-float')
    }
  } else {
    navBar.classList.remove('nav-float-show', 'nav-float')
    navBar.classList.add('nav-float-hide')
  }

  // Update last scroll position
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
})
